import {
  HttpEvent,
  HttpHandler,
  HttpHeaders,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { concatMap, filter, map, mergeMap, retryWhen, switchMap, take } from 'rxjs/operators';
import { Signature } from './signature.model';
import { SignatureService } from './signature.service';
@Injectable()
export class SignatureInterceptor implements HttpInterceptor {
  constructor(private service: SignatureService) {}

  constructHeaders(signature: Signature | null): HttpHeaders {
    let headers = new HttpHeaders({});
    if (!signature) return headers;
    headers = headers
      .set('service_auth_user_token', signature.user_token)
      .set('service_auth_timestamp', signature.timestamp)
      .set('service_auth_nonce', signature.nonce.toString())
      .set('service_auth_signature', signature.signature.replace(/\n$/, ''));
    return headers;
  }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const useInterceptor = req.headers.get('use_signature_interceptor');

    if (!useInterceptor) return next.handle(req);

    return this.service.refreshTokenSubject$.pipe(
      take(1),
      map(
        (signature: Signature | null): HttpRequest<any> =>
          req.clone({ headers: this.constructHeaders(signature) })
      ),
      concatMap((req) => next.handle(req)),
      retryWhen((errors: Observable<any>) =>
        errors.pipe(
          mergeMap((error, index) => {
            if (error.status === 401) {
              if (this.service.refreshTokenInProgress) {
                return this.service.refreshTokenSubject$.pipe(
                  filter((result) => result !== null),
                  switchMap((signature) => {
                    req = req.clone({
                      headers: this.constructHeaders(signature),
                    });
                    return next.handle(req);
                  })
                );
              }

              this.service.refreshTokenInProgress = true;
              return this.service.getSignature().pipe(
                map((signature): Observable<HttpEvent<any>> => {
                  this.service.refreshTokenInProgress = false;
                  this.service.refreshTokenSubject$.next(signature);
                  req = req.clone({
                    headers: this.constructHeaders(signature),
                  });
                  return next.handle(req);
                })
              );
            }
            return throwError(error);
          }),
          take(2)
        )
      )
    );
  }
}
